import { getContentAssetUrl } from "@client/content/lib/assets";
import { makeModuleStateSelector } from "@client/content/selectors";
import { getImage, getInherittedSettingValue } from "@client/lib/settings";
import { entitiesSelector, isEditModeSelector, screenSelector } from "@client/selectors";
import { createSelector } from "reselect";
import { defaultState, previewState } from "./reducer";
import { type ImageGalleryState } from "./types";

export const localStateSelector = makeModuleStateSelector<ImageGalleryState>(defaultState, previewState);

export const makePreviewImageSrcSelector = () => {
  return createSelector(
    [localStateSelector, entitiesSelector, isEditModeSelector, screenSelector],
    (localState, entities, isEditMode, screen): string | null => {
      if (!localState.selectedItemId) return null;

      const image = getInherittedSettingValue(entities[localState.selectedItemId].settings!, "", "image", screen);
      return getContentAssetUrl(getImage(image, isEditMode));
    }
  );
};
